import React from "react";
import { ScreenContainerControl } from "doshx_controls_web";
import { Breadcrumb } from "../../../components/breadcrumb";
import { TermsAndConditions } from "../terms_and_conditions";
export const TermsAndConditionsPage = () => {
    return (React.createElement("div", null,
        React.createElement(Breadcrumb, { items: [{ label: "Home" }, { label: "Terms & Conditions", active: true }], title: "Terms & Conditions" }),
        React.createElement(ScreenContainerControl, null,
            React.createElement(TermsAndConditions, null))));
};
